export const getDataFromLocalStorage = function(keyValue: string, parse: boolean) {
    for (let i = 0; i < localStorage.length; i++) {
        let key = localStorage.key(i);
        if (localStorage.key(i)?.startsWith(keyValue) && parse === true) {
            return JSON.parse(localStorage.getItem(key!)!);            
        }else if(localStorage.key(i)?.startsWith(keyValue) && parse === false){ 
            return localStorage.getItem(key!);
        }
    }
}